import React from 'react'
import classNames from 'classnames'

import { withStyles, createStyles, WithStyles } from '@material-ui/core'

import defaultAvatar from 'assets/images/default_user_avatar.png'

type UserPhotoSize = 'small' | 'medium' | 'large'

interface Props {
  src?: string | null
  size?: UserPhotoSize
  className?: string
  onClick?: () => void
}

const styles = createStyles({
  root: {
    display: 'block',
    borderRadius: '50%',
  },
  small: {
    width: 20,
    height: 20,
  },
  medium: {
    width: 40,
    height: 40,
  },
  large: {
    width: 80,
    height: 80,
  },
})

type InjectedProps = Props & WithStyles<typeof styles>

const UserPhoto: React.SFC<InjectedProps> = ({ classes, size, src, className, onClick }) => (
  <img
    alt=""
    onClick={onClick}
    src={src || defaultAvatar}
    className={classNames(classes.root, classes[size || 'medium'], className)}
  />
)

export default withStyles(styles)(UserPhoto)
